export default "__VITE_ASSET__BmCztNVp__"